<template>
  <symbol
    id="angle-down"
    viewBox="0 0 18 10"
  >
    <path
      d="M8.9999 7.8941L1.60601 0.615417L0.553711 1.68437L8.9999 9.99895L17.4461 1.68437L16.3938 0.615417L8.9999 7.8941Z"
    />
  </symbol>
</template>
